import {
  GatewayAvancement,
  GatewayDeclarationActivite,
} from "@conformite/gateway";
import { userSession } from "@src/session/UserSession";

export class GatewayDeclarationActiviteApi {
  public static async getIAS(
    siren: string,
    millesime: number
  ): Promise<GatewayDeclarationActivite.DeclarationActiviteIas | null> {
    const response =
      await userSession.axiosInstance.get<GatewayDeclarationActivite.DeclarationActiviteIas | null>(
        GatewayDeclarationActivite.declarationActiviteUrl(
          siren,
          millesime,
          "ias"
        )
      );
    return response.data;
  }

  public static async getIobsp(
    siren: string,
    millesime: number
  ): Promise<GatewayDeclarationActivite.DeclarationActiviteIobsp | null> {
    const response =
      await userSession.axiosInstance.get<GatewayDeclarationActivite.DeclarationActiviteIobsp | null>(
        GatewayDeclarationActivite.declarationActiviteUrl(
          siren,
          millesime,
          "iobsp"
        )
      );
    return response.data;
  }

  public static async saveIAS(
    declarationActivite: GatewayDeclarationActivite.DeclarationActiviteIas
  ): Promise<GatewayAvancement.AvancementSociete> {
    const response =
      await userSession.axiosInstance.post<GatewayAvancement.AvancementSociete>(
        GatewayDeclarationActivite.declarationActiviteUrl(
          declarationActivite.siren,
          declarationActivite.millesime,
          "ias"
        ),
        declarationActivite
      );
    return response.data;
  }

  public static async saveIobsp(
    declarationActivite: GatewayDeclarationActivite.DeclarationActiviteIobsp
  ): Promise<GatewayAvancement.AvancementSociete> {
    const response =
      await userSession.axiosInstance.post<GatewayAvancement.AvancementSociete>(
        GatewayDeclarationActivite.declarationActiviteUrl(
          declarationActivite.siren,
          declarationActivite.millesime,
          "iobsp"
        ),
        declarationActivite
      );
    return response.data;
  }

  public static async copy(
    source: { siren: string; millesime: number; categorie: "ias" | "iobsp" },
    destination: { sirens: string[] }
  ): Promise<GatewayAvancement.AvancementSociete[]> {
    const response = await userSession.axiosInstance.post<
      GatewayAvancement.AvancementSociete[]
    >(
      GatewayDeclarationActivite.copyActiviteUrl(
        source.siren,
        source.millesime,
        source.categorie
      ),
      { source, destination }
    );
    return response.data;
  }

  public static async getIASAdmin(
    siren: string,
    millesime: number
  ): Promise<GatewayDeclarationActivite.DeclarationActiviteIas | null> {
    const response =
      await userSession.axiosInstance.get<GatewayDeclarationActivite.DeclarationActiviteIas | null>(
        `/admin/declaration-activite/${siren}/${millesime}/ias`
      );
    return response.data;
  }

  public static async getIobspAdmin(
    siren: string,
    millesime: number
  ): Promise<GatewayDeclarationActivite.DeclarationActiviteIobsp | null> {
    const response =
      await userSession.axiosInstance.get<GatewayDeclarationActivite.DeclarationActiviteIobsp | null>(
        `/admin/declaration-activite/${siren}/${millesime}/iobsp`
      );
    return response.data;
  }
}
